import React, { useContext, useState, useEffect } from "react";
import { motion } from "framer-motion";
import Contact from "../components/Contact/Contact";
import Footer from "../components/Footer/Footer";
import OfficeTitle from "../components/Three/OfficeTitle";
import LoadingHome from "../components/Loading/LoadingHome";
import { Context } from "../context";

const ContactPage = () => {
  const { debug, lang } = useContext(Context);
  const [text, setText] = useState("");
  const [text2, setText2] = useState("");

  useEffect(() => {
    if (lang === "en") {
      setText("Contacts");
      setText2("Contact me for collaboration");
    } else if (lang === "it") {
      setText("Contatti");
      setText2("Contattami per collaborazioni");
    }
  }, [lang]);

  return (
    <>
      <title>Davide Balice - Contacts</title>
      <LoadingHome />
      <motion.main
        initial={{ opacity: 0.6, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0.6 }}
        transition={{ duration: 0.4, delay: 1 }}
      >
        <OfficeTitle text={text} text2={text2} />
        <Contact />
        <Footer />
      </motion.main>
    </>
  );
};

export default ContactPage;
